import { render, staticRenderFns } from "./AppLink.vue?vue&type=template&id=937881c4&scoped=true&"
import script from "./AppLink.vue?vue&type=script&lang=js&"
export * from "./AppLink.vue?vue&type=script&lang=js&"
import style0 from "./AppLink.vue?vue&type=style&index=0&id=937881c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937881c4",
  null
  
)

export default component.exports